import { Dispatch } from 'redux';
import { userExportService } from 'common';

import {
  fetchRecentReportsService,
  GetRecentReportsSuccessType,
  GET_RECENT_REPORTS_SUCCESS,
  SET_RECENT_REPORTS_LOADING,
  SetRecentReportsLoadingType,
  RecentReportsDOMType,
} from '.';
import { RecentReportsResult } from './models';
import { saveFile, printFile } from 'common/helpers';

const setLoading = (loading: boolean): SetRecentReportsLoadingType => ({
  type: SET_RECENT_REPORTS_LOADING,
  loading,
});

const GetRecentReportsSuccess = (
  recentReports: RecentReportsResult,
): GetRecentReportsSuccessType => ({
  type: GET_RECENT_REPORTS_SUCCESS,
  recentReports,
});

export const getRecentReports =
  (daysCount: number, token: string) => async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await fetchRecentReportsService(
        daysCount,
        token,
        dispatch,
      );
      if (response.errorMessage) throw Error(response.errorMessage);
      dispatch(GetRecentReportsSuccess(response));
    } catch ({ message }) {
      //showWarnNotification(FETCH_HEADER, message);
    }
    dispatch(setLoading(false));
  };

export const exportReport =
  (report: RecentReportsDOMType, print = false, token: string) =>
  async (dispatch: Dispatch) => {
    const fileName = report.fileName
      ? report.fileName
      : `Report.${report.fileFormat}`;
    dispatch(setLoading(true));
    try {
      const blob = await userExportService(report, token, dispatch);
      dispatch(setLoading(false));
      return print ? printFile(blob) : saveFile(blob, fileName);
    } catch (error) {
      dispatch(setLoading(false));
      //showWarnNotification(FETCH_HEADER, error.message);
    }
  };
